import get from 'lodash/get';

export const selectFirstRestaurantLocationError = state =>
  get(state, 'restaurantLocations.error[0]', null);
